<template>
  <main class="verify-page">
    <section class="verify-card" aria-labelledby="verify-title">
      <div class="status-visual" aria-hidden="true">
        <span class="status-icon">×</span>
      </div>

      <h1 id="verify-title" class="title">Invalid Link</h1>
      <p class="description">
        This verification link is invalid or has expired. Please request a new verification email from your account
        settings.
      </p>

      <div class="actions">
        <button type="button" class="primary-btn" @click="requestNewLink">
          <svg class="btn-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M17.7 7.3A7 7 0 1 0 19 12h-2.2a4.8 4.8 0 1 1-.8-2.6L13.8 11H20V4.8L17.7 7.3Z" />
          </svg>
          Request New Link
        </button>
        <button type="button" class="secondary-btn" @click="backHome">
          <svg class="btn-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 10.8 12 4l8 6.8v8.4a.8.8 0 0 1-.8.8H15v-5.4H9V20H4.8a.8.8 0 0 1-.8-.8v-8.4Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
          </svg>
          Back to Home
        </button>
      </div>
    </section>

    <p class="support-text">
      Need help?
      <a href="">Contact Support</a>
    </p>

    <p class="page-tagline">AI TUTOR · THE FUTURE OF EDUCATION</p>
  </main>
</template>

<script>
export default {
  name: 'VerifyInvalid',
  methods: {
    /**
     * 引导用户回到注册流程重新获取邮箱验证链接。
     */
    requestNewLink () {
      this.$router.push('/verify-email')
    },
    /**
     * 返回公开首页。
     */
    backHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.verify-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px 76px;
  background:
    radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.85), transparent 36%),
    linear-gradient(180deg, #f0edff 0%, #eef2ff 50%, #eef5ff 100%);
  color: #111827;
  font-family: "Inter", "Segoe UI", Arial, sans-serif;
}

.verify-card {
  width: min(100%, 430px);
  padding: 40px 40px 38px;
  text-align: center;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 26px 70px rgba(99, 102, 241, 0.08);
}

.status-visual,
.title,
.description,
.actions {
  margin-inline: auto;
}

.status-visual {
  width: 78px;
  height: 78px;
  display: grid;
  place-items: center;
  margin: 0 auto 26px;
}

.status-icon {
  width: 78px;
  height: 78px;
  display: grid;
  place-items: center;
  border-radius: 17px;
  background: linear-gradient(135deg, #ff385f 0%, #d91672 100%);
  box-shadow: 0 12px 24px rgba(225, 29, 88, 0.22);
  color: #fff;
  font-size: 46px;
  font-weight: 300;
  line-height: 0.9;
}

.title {
  margin: 0;
  color: #111827;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
}

.description {
  max-width: 350px;
  margin: 11px auto 32px;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.55;
}

.actions {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 14px;
}

.primary-btn,
.secondary-btn {
  width: 100%;
  min-height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 14px;
  padding: 0 22px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.primary-btn {
  color: #fff;
  border: 0;
  background: linear-gradient(90deg, #ff385f 0%, #d91672 100%);
  box-shadow: 0 12px 20px rgba(225, 29, 88, 0.18);
}

.secondary-btn {
  color: #5f6673;
  background: #fff;
  border: 1px solid #edf0f5;
  box-shadow: 0 8px 18px rgba(17, 24, 39, 0.04);
}

.btn-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  fill: currentColor;
}

.primary-btn:hover,
.secondary-btn:hover {
  transform: translateY(-2px);
}

.primary-btn:hover {
  box-shadow: 0 16px 28px rgba(225, 29, 88, 0.24);
}

.secondary-btn:hover {
  color: #111827;
  border-color: #d9dee8;
  box-shadow: 0 12px 24px rgba(17, 24, 39, 0.08);
}

.support-text {
  margin: 26px 0 0;
  color: #9aa2b1;
  font-size: 13px;
  font-weight: 600;
}

.support-text a {
  color: #7c3aed;
  font-weight: 700;
  text-decoration: none;
}

.support-text a:hover {
  text-decoration: underline;
}

.page-tagline {
  position: fixed;
  left: 50%;
  bottom: 22px;
  transform: translateX(-50%);
  color: #a6adbb;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

@media (max-width: 640px) {
  .verify-page {
    padding: 28px 18px 52px;
  }

  .verify-card {
    padding: 36px 26px 34px;
  }

  .status-visual {
    width: 70px;
    height: 70px;
  }

  .status-icon {
    width: 70px;
    height: 70px;
    font-size: 42px;
  }

  .description {
    font-size: 13px;
  }

  .primary-btn,
  .secondary-btn {
    width: 100%;
  }
}

</style>
